import React, { useLayoutEffect, useState } from 'react'
import { JobOfferCard } from './styled'
import { API } from 'javascripts/api'
import { JobOfferCardProps } from './types'

const Index: React.FC<JobOfferCardProps> = props => {
  const [isFavorite, setIsFavorite] = useState<boolean>(props.isFavorite)
  const [isApplied, setIsApplied] = useState<boolean>(props.isApplied)

  useLayoutEffect(() => {
    setIsFavorite(props.isFavorite)
    setIsApplied(props.isApplied)
  }, [props])

  const handleFavoriteClicked: React.MouseEventHandler<HTMLAnchorElement> = (event): void => {
    event.preventDefault()

    const jobOfferId = Number(props.jobOffer.id)
    if (isFavorite) {
      void API.deleteJobOffersFavorite(jobOfferId)
    } else {
      void API.updateJobOffersFavorite(jobOfferId)
    }

    setIsFavorite(!isFavorite)
  }

  return (
    <JobOfferCard
      jobOffer={props.jobOffer}
      isFavorite={isFavorite}
      isApplied={isApplied}
      borderDirection={props.borderDirection}
      onClick={handleFavoriteClicked}
    />
  )
}

export default Index
